import { endOfMonth, endOfYear, subMonths, subYears } from 'date-fns';
import {RankingPeriod} from '../../types/RankingPeriod';

export class RankingHelper {
    public getPeriodDate(period: RankingPeriod): Date {
        switch (period) {
            case 'current-month':
            case 'current-year':
                return new Date();
            case 'last-month':
                return endOfMonth(subMonths(new Date(), 1));
            case 'last-year':
                return endOfYear(subYears(new Date(), 1));
            default:
                throw new Error(`Unknown period in getPeriodDate: ${period}`);
        }
    }

    public getPeriod(period: RankingPeriod): string {
        switch (period) {
            case 'current-month':
            case 'last-month':
                return 'monthly';
            case 'current-year':
            case 'last-year':
                return 'yearly';
            default:
                throw new Error(`Unknown period in getPeriod: ${period}`);
        }
    }
}
